/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_membership_includes: Phrase =locale => {
  const en = `Membership Includes`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `La membresía incluye`,
  };
  return phrases[locale] || en;
};
            